<template>
  <div class="operaterule">
    <Nav></Nav>
    <div class="operaterule-box">
      <div class="operaterule-inner">
        <div class="operaterule-wraper">
          <div class="page-title-box">
            <span class="curlybracket">{</span>
            <span class="title-cont">运营规则</span>
            <span class="curlybracket">}</span>
          </div>
          <div class="page-title-enbox">Operation Rules</div>
          <div class="module-title-box module-title-box1">
            <div class="number">01</div>
            <div class="title-description-box">适合整个IT 行业的从业人员</div>
            <div class="title-wraper">建立自己的组织</div>
          </div>
          <div class="module-box module-box1">
            <div class="label-box">
              <div class="label-cont">邀请方式与规则</div>
            </div>
            <div class="module1-inner">
              <div class="module1-item">
                <div class="sort-box">
                  <img class="icon-sort" src="@/assets/icon_sort_person.png" />
                </div>
                <div class="invitcount-cont">邀请一人：</div>
                <div class="item-cont">解锁一折券，专业版首年年费打一折</div>
              </div>
              <div class="module1-item">
                <div class="sort-box">
                  <img class="icon-sort" src="@/assets/icon_sort_person.png" />
                  <img class="icon-sort" src="@/assets/icon_sort_person.png" />
                </div>
                <div class="invitcount-cont">邀请两人：</div>
                <div class="item-cont">
                  解锁5000元的项目发布抵扣券、发布项目时相当于你多赚了5000元，非常实用。
                </div>
              </div>
              <div class="module1-item">
                <div class="sort-box">
                  <img class="icon-sort" src="@/assets/icon_sort_person.png" />
                  <img class="icon-sort" src="@/assets/icon_sort_person.png" />
                  <img class="icon-sort" src="@/assets/icon_sort_person.png" />
                </div>
                <div class="invitcount-cont">邀请三人：</div>
                <div class="item-cont">
                  解锁订单发布与获得渠道：每月会不定期给你推荐开发项目，或者反向发布需求平台帮定你搞定一切，你就坐等收益。
                </div>
              </div>
            </div>
          </div>
          <div class="module-box module-box2">
            <img
              class="bg_operaterule_round"
              src="@/assets/bg_operaterule_round.png"
            />
            <div class="label-box">
              <div class="label-cont">
                收益规则<span class="description"
                  >通过你邀请的人员，发生以及下交易您将获得收益：</span
                >
              </div>
            </div>
            <div class="module2-inner">
              <div class="module2-item">
                <div class="sort-box">
                  <div class="num-sort">1</div>
                </div>
                <div class="item-cont">
                  <div class="width220">升级成为专业版会员获得：</div>
                  <div class="special">10%佣金</div>
                </div>
              </div>
              <div class="module2-item">
                <div class="sort-box">
                  <div class="num-sort">2</div>
                </div>
                <div class="item-cont">
                  <div class="width220">通过独自开发布项目获得：</div>
                  <div class="special">4500~27000元的佣金</div>
                </div>
              </div>
              <div class="module2-item">
                <div class="sort-box">
                  <div class="num-sort">3</div>
                </div>
                <div class="item-cont">
                  <div>
                    你所向平台提供的一切订单线索信息后都会有不低于<span
                      class="special"
                      >10%</span
                    >的收益
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="module-tip-box">
            规则有效期：凡是通过您要求加入到独自开平台的成员，终身享受交易收益。所以，赶快邀请你身边的程序员加入吧，建设共同富裕的组织圈。
          </div>
          <div class="module-title-box module-title-box2">
            <div class="number">02</div>
            <div class="title-description-box">适合开发者</div>
            <div class="title-wraper">
              大胆的接单，独自开团队会帮你搞定一切困难
            </div>
          </div>
          <div class="module-box module-box3">
            <img
              class="bg_operaterule_round"
              src="@/assets/bg_operaterule_round.png"
            />
            <div class="bg_round2">
              <img
                class="img-round2-1"
                src="@/assets/bg_operaterule_circle.png"
              />
              <img
                class="img-round2-2"
                src="@/assets/bg_operaterule_circle.png"
              />
            </div>
            <div class="module3-inner">
              <div class="module3-item">
                <div class="sort-box">
                  <div class="num-sort">1</div>
                </div>
                <div class="item-cont">
                  <div class="">独自开团队会向专业版用户推荐项目开发</div>
                </div>
              </div>
              <div class="module3-item">
                <div class="sort-box">
                  <div class="num-sort">2</div>
                </div>
                <div class="item-cont">
                  <div>
                    所有平台会员都可以将身边的开发需求发布给独自开平台从而获得收益
                  </div>
                </div>
              </div>
              <div class="module3-item">
                <div class="sort-box">
                  <div class="num-sort">3</div>
                </div>
                <div class="item-cont">
                  <div class="">
                    下载独自开开发工具包，实现一个人独自开发一套系统。
                  </div>
                </div>
              </div>
            </div>
            <!-- <img class="" src="@/assets/bg_operaterule_code.png" /> -->
          </div>

          <div class="module-title-box module-title-box3">
            <div class="number">03</div>
            <div class="title-description-box">
              适合IT、数字领域的全部从业人员
            </div>
            <div class="title-wraper">发掘身边需求</div>
          </div>
          <div class="process-step-box">
            <div class="process-item">
              <img class="img-step" src="@/assets/operaterule_step1.png" />
              <div class="step-text">发布需求</div>
            </div>
            <img class="step-arrow-img" src="@/assets/step_arrow.png" />
            <div class="process-item">
              <img class="img-step" src="@/assets/operaterule_step2.png" />
              <div class="step-text">受理需求</div>
            </div>
            <img class="step-arrow-img" src="@/assets/step_arrow.png" />
            <div class="process-item">
              <img class="img-step" src="@/assets/operaterule_step3.png" />
              <div class="step-text">达成交易</div>
            </div>
            <img class="step-arrow-img" src="@/assets/step_arrow.png" />
            <div class="process-item">
              <img class="img-step" src="@/assets/operaterule_step4.png" />
              <div class="step-text">赚取佣金</div>
            </div>
          </div>
          <div class="btn-publish" @click="handleToUserCenter">
            向独自开平台发布需求赚钱佣金
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
    <ButtonFeedback></ButtonFeedback>
  </div>
</template>

<script>
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import DialogApplyInfo from "@/components/dialog/ApplyInfo";
import ButtonFeedback from "@/components/ButtonFeedback";
import pageCommon from "@/utils/pagecommon";
import caseApi from "@/api/case";
import lodash from "lodash";
export default {
  name: "OperateRule",
  components: {
    Nav,
    Footer,
    DialogApplyInfo,
    ButtonFeedback,
  },

  data() {
    return {};
  },
  computed: {
    systemUser: function () {
      let _this = this;
      let systemUser = _this.$store.state.systemUser;
      return systemUser;
    },
    userInfo: function () {
      let _this = this;
      let userInfo = _this.$store.state.user;
      return userInfo;
    },
    userShopInfo: function () {
      let _this = this;
      let userShopInfo = _this.$store.state.userShopInfo;
      return userShopInfo;
    },
  },
  mounted() {
    let _this = this;
    _this.$store.dispatch("acNavIndex", 4);
  },
  methods: {
    handleToUserCenter: function () {
      let _this = this;
      if (_this.userInfo) {
        let _this = this;
        _this.$router.push("/mydemand");
      }
      else{
        _this.$router.push("/login")
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/common.less";
.operaterule {
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    vertical-align: top;
  }
  .operaterule-box {
    width: 100%;
    color: #ffffff;
    font-size: 30px;
    overflow: hidden;

    .operaterule-inner {
      min-width: 1200px;
      padding-top: 80px;
      height: 100%;
      margin: 0 auto;
      overflow: hidden;
      box-sizing: border-box;
      .operaterule-wraper {
        position: relative;
        width: 100%;
        min-width: 1200px;
        padding-bottom: 100px;
        // height: 3000px;
        background: url(~@/assets/bg_operaterule.png) no-repeat center top
          #000000;
        background-size: 1920px 1298px;
        .page-title-box {
          position: relative;
          width: 100%;
          padding-top: 80px;
          text-align: center;
          box-sizing: border-box;
          .curlybracket {
            position: relative;
            font-size: 40px;
            font-family: Source Han Sans CN;
            font-weight: 800;
            color: #0072ff;
            line-height: 40px;
          }

          .title-cont {
            position: relative;
            font-size: 40px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ffffff;
            line-height: 40px;
            padding-left: 14px;
            padding-right: 14px;
          }
        }
        .page-title-enbox {
          position: relative;
          width: 100%;
          margin-top: 25px;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #999999;
          line-height: 20px;
        }
        .module-title-box {
          position: relative;
          width: 100%;
          display: flex;
          display: -webkit-flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .number {
            position: relative;
            font-size: 80px;
            font-family: Source Han Sans CN;
            font-weight: 800;
            color: #5a5d69;
            line-height: 80px;
            opacity: 0.2;
          }

          .title-description-box {
            position: relative;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ffffff;
            line-height: 16px;
            margin-top: 18px;
          }
          .title-wraper {
            position: absolute;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ec4040;
            line-height: 24px;
            padding-bottom: 16px;
            border-bottom: 1px solid #5a5d69;
            box-sizing: border-box;
            &::after {
              position: absolute;
              content: "";
              width: 126px;
              height: 3px;
              background: #0072ff;
              bottom: -2px;
              left: 50%;
              transform: translate(-50%, 0);
              -webkit-transform: translate(-50%, 0);
            }
          }
        }
        .module-title-box1 {
          margin-top: 80px;
        }
        .module-title-box2,
        .module-title-box3 {
          margin-top: 100px;
        }
        .module-box {
          position: relative;
          width: 938px;
          margin: 40px auto 0;
          background: rgba(23, 21, 28, 0.6);
          border: 1px solid #ec4040;
          border-radius: 4px;
          box-sizing: border-box;
        }
        .label-box {
          position: relative;
          min-width: 202px;
          height: 51px;
          // margin-top: 16px;
          margin-left: -12px;
          background: url(~@/assets/bg_label_1.png) no-repeat left center;
          background-size: 202px 100%;
          text-align: left;
          .label-cont {
            position: relative;
            font-size: 20px;
            line-height: 20px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ffffff;
            padding-left: 30px;
            padding-top: 9px;
            .description {
              position: relative;
              font-size: 16px;
              line-height: 16px;
              font-family: Source Han Sans CN;
              // font-weight: bold;
              font-weight: normal;
              color: #ffffff;
              padding-left: 50px;
              box-sizing: border-box;
            }
          }
        }
        .module-box1 {
          padding-top: 16px;
          padding-bottom: 30px;
          .module1-inner {
            position: relative;
            width: 100%;
            margin-top: 20px;
            .module1-item {
              position: relative;
              width: 100%;
              display: flex;
              display: -webkit-flex;
              flex-direction: row;
              margin-top: 30px;
              box-sizing: border-box;
              &:first-child {
                margin-top: 0;
              }
              .sort-box {
                position: relative;
                width: 124px;
                margin-right: 16px;
                display: flex;
                display: -webkit-flex;
                flex-direction: row;
                justify-content: flex-end;
                .icon-sort {
                  position: relative;
                  width: 20px;
                  height: 19px;
                  margin-top: 7px;
                  margin-left: 4px;
                  &:first-child{
                    margin-left: 0;
                  }
                }
              }
              .invitcount-cont{
                position: relative;
                font-size: 18px;
                font-family: Source Han Sans CN;
                // font-weight: bold;
                color: #ffffff;
                line-height: 32px;
                text-align: left;
                margin-right: 17px;
              }
              .item-cont {
                position: relative;
                width: 646px;
                font-size: 18px;
                font-family: Source Han Sans CN;
                // font-weight: bold;
                color: #ffffff;
                line-height: 32px;
                text-align: left;
              }
            }
          }
        }
        .module-box2 {
          padding-top: 16px;
          padding-bottom: 30px;
          margin-top: 20px;
          box-shadow: 0px 4px 16px 0px rgba(210, 29, 29, 0.15);
          .label-box{
            background: url(~@/assets/bg_label_2.png) no-repeat left center;
          background-size: 141px 100%;
          }
          .module2-inner {
            position: relative;
            width: 100%;
            margin-top: 20px;
            .module2-item {
              position: relative;
              width: 100%;
              display: flex;
              display: -webkit-flex;
              flex-direction: row;
              margin-top: 30px;
              box-sizing: border-box;
              &:first-child {
                margin-top: 0;
              }
              .sort-box {
                position: relative;
                width: 117px;
                margin-right: 16px;
                display: flex;
                display: -webkit-flex;
                flex-direction: row;
                justify-content: flex-end;
                .num-sort {
                  position: relative;
                  width: 24px;
                  height: 24px;
                  text-align: center;
                  line-height: 24px;
                  background: #ffffff;
                  border-radius: 50%;
                  box-sizing: border-box;

                  font-size: 16px;
                  font-family: Source Han Sans CN;
                  font-weight: bold;
                  color: #222222;
                }
              }
              .item-cont {
                position: relative;
                width: 646px;
                font-size: 18px;
                font-family: Source Han Sans CN;
                // font-weight: bold;
                color: #ffffff;
                line-height: 24px;
                text-align: left;
                display: flex;
                display: -webkit-flex;
                flex-direction: row;
                .width220 {
                  width: 220px;
                }
                .special {
                  color: rgba(0, 114, 255, 1);
                  font-weight: bold;
                }
              }
            }
          }
          .bg_operaterule_round {
            position: absolute;
            width: 262px;
            height: 262px;
            left: 760px;
            top: 135px;
          }
        }
        .module-tip-box {
          position: relative;
          width: 100%;
          font-size: 14px;
          line-height: 14px;
          font-family: Source Han Sans CN;
          // font-weight: bold;
          color: #0072ff;
          text-align: center;
          margin-top: 24px;
        }
        .module-box3 {
          padding-top: 30px;
          padding-bottom: 30px;
          box-shadow: 0px 4px 16px 0px rgba(210, 29, 29, 0.15);
          background: url(~@/assets/bg_operaterule_code.png) no-repeat 821px
            62px;
          background-size: 83px 70px;
          .module3-inner {
            position: relative;
            width: 100%;
            margin-top: 20px;
            .module3-item {
              position: relative;
              width: 100%;
              display: flex;
              display: -webkit-flex;
              flex-direction: row;
              margin-top: 30px;
              box-sizing: border-box;
              &:first-child {
                margin-top: 0;
              }
              .sort-box {
                position: relative;
                width: 156px;
                margin-right: 16px;
                display: flex;
                display: -webkit-flex;
                flex-direction: row;
                justify-content: flex-end;
                .num-sort {
                  position: relative;
                  width: 24px;
                  height: 24px;
                  text-align: center;
                  line-height: 24px;
                  background: #ffffff;
                  border-radius: 50%;
                  box-sizing: border-box;

                  font-size: 16px;
                  font-family: Source Han Sans CN;
                  font-weight: bold;
                  color: #222222;
                }
              }
              .item-cont {
                position: relative;
                width: 646px;
                font-size: 18px;
                font-family: Source Han Sans CN;
                // font-weight: bold;
                color: #ffffff;
                line-height: 24px;
                text-align: left;
                display: flex;
                display: -webkit-flex;
                flex-direction: row;
                .width220 {
                  width: 220px;
                }
                .special {
                  color: rgba(0, 114, 255, 1);
                  font-weight: bold;
                }
              }
            }
          }
          .bg_operaterule_round {
            position: absolute;
            width: 262px;
            height: 262px;
            left: -241px;
            top: -215px;
          }
          .bg_round2 {
            position: absolute;
            width: 134px;
            height: 134px;
            left: -67px;
            .img-round2-1,
            .img-round2-2 {
              position: relative;
              width: 67px;
              height: 134px;
            }
            .img-round2-1 {
              // transform-origin: right center;
              // -webkit-transform-origin: right center;
              transform: rotate(180deg);
              -webkit-transform: rotate(180deg);
            }
          }
        }
        .process-step-box {
          position: relative;
          width: 822px;
          margin: 40px auto 0;
          display: flex;
          display: -webkit-flex;
          flex-direction: row;
          justify-content: space-between;
          .process-item {
            position: relative;
            width: 112px;
            display: flex;
            display: -webkit-flex;
            flex-direction: column;
            align-items: center;
            .img-step {
              position: relative;
              width: 112px;
              height: 112px;
            }
            .step-text {
              position: relative;
              margin-top: 38px;
              font-size: 22px;
              line-height: 22px;
              font-family: Source Han Sans CN;
              font-weight: 800;
              color: #ffffff;
            }
          }
          .step-arrow-img {
            position: relative;
            width: 49px;
            height: 32px;
            margin-top: 40px;
          }
        }
        .btn-publish {
          position: relative;
          width: 330px;
          height: 46px;
          line-height: 46px;
          background: rgba(130, 130, 130, 0.35);
          border: 1px solid #828282;
          box-shadow: 0px 5px 13px 0px rgba(12, 21, 99, 0.35);
          text-align: center;
          margin: 52px auto 99px;
          box-sizing: border-box;

          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #0072ff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
